import * as React from "react";
import type { SVGProps } from "react";
const SvgActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <circle
      cx={8.399}
      cy={8.002}
      r={6.003}
      stroke="#2C9746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#2C9746"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10.833 6.684-2.625 2.8-1.575-1.68"
    />
  </svg>
);
export default SvgActive;
